export const PRESENTER_BIT_RATE_CHANGED = 'presenterBitRateChanged';
export const MUTE_MEETING_AUDIO_CHANGED = 'muteMeetingAudioChanged';
export const TOGGLE_AGORA_PRESENTER_LIVE = 'toggleAgoraPresenterLive';
export const TOGGLED_ADD_SELF_LIVE = 'toggledAddSelfLive';
export const TOGGLED_LAYOUT_ANIMATION = 'toggledLayoutAnimation';
export const CREATED_READINESS_CHECK = 'createdReadinessCheck';
export const ATTENDEE_DETAILS_CHANGED = 'attendeeDetailsChanged';
export const ATTENDEE_SCREEN_SHARE_CANCEL = 'attendeeScreenShareCancel';
export const ATTENDEE_SCREEN_SHARE_CANCELLED = 'attendeeScreenShareCancelled';
export const MULTIPLE_MUTE_CHANGED = 'multipleMuteChanged';
export const MULTIPLE_CAMERA_STATUSES_CHANGED = 'multipleCameraStatusesChanged';
export const KNOCK_FAILED = 'knockFailed';
export const RENEWED_MEETING = 'renewedMeeting';
export const SYNCED_BRANDING_SETTINGS = 'syncedBrandingSettings';
export const AUTO_MUTE_TOGGLED = 'autoMuteToggled';
